import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

import { loginStatusVar } from '@context';
import { useConnection } from '@hooks';
import { SignupSSOForm } from './SignupSSOForm';
import { useTranslation } from 'react-i18next';

export function OAuthRegisterDialog() {
  const { logout } = useConnection();
  const loginStatus = useReactiveVar(loginStatusVar);
  const [open, setOpen] = React.useState(false);
  const [displayCancelButton, setDisplayCancelButton] = React.useState(true);
  const { t } = useTranslation('cta');
  const navigate = useNavigate();

  React.useEffect(() => {
    if (loginStatus.mustFinalizeRegister) {
      setOpen(true);
    }
  }, [loginStatus]);

  const handleCancel = async () => {
    logout();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    navigate('/', { replace: true });
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose} slotProps={{ transition: Transition }}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar sx={{ backgroundColor: 'background.default' }}>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {t('Finalizing registration', { ns: 'authentication' })}
          </Typography>
          {displayCancelButton && (
            <Button variant="outlined" color="uncolored" onClick={handleCancel}>
              {t('cancel & disconnect')}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Stack height="100%" p={3} justifyContent="center" alignItems="center">
        <SignupSSOForm handleClose={handleClose} setDisplayCancelButton={setDisplayCancelButton} />
      </Stack>
    </Dialog>
  );
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
